import { render, staticRenderFns } from "./ReportConfig.vue?vue&type=template&id=f85a7768&scoped=true&"
import script from "./ReportConfig.vue?vue&type=script&lang=js&"
export * from "./ReportConfig.vue?vue&type=script&lang=js&"
import style0 from "./ReportConfig.vue?vue&type=style&index=0&id=f85a7768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85a7768",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VSelect,VSwitch,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f85a7768')) {
      api.createRecord('f85a7768', component.options)
    } else {
      api.reload('f85a7768', component.options)
    }
    module.hot.accept("./ReportConfig.vue?vue&type=template&id=f85a7768&scoped=true&", function () {
      api.rerender('f85a7768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/ReportConfig.vue"
export default component.exports